import httpUtil from '../utils/httpUtil'
import {get} from "@/utils/request";

/**任务管理列表 */

export const queryPage = params => httpUtil.get("/print/special", params);

/**添加任务 */
export const add = params => httpUtil.post("/print/special", params);

/**删除任务 */
export const deleteById = params => httpUtil.delete("/print/special", params);


/** 获取批次号列表 */
export const getTaskNums = params => httpUtil.get("/print/special/getLotNumber", params);

/**编辑 */
export const update = params => httpUtil.put("/print/special", params);





